/* Tegrino — Designer 配置器界面运行时翻译覆盖层
 * ------------------------------------------------------------------
 * 为什么要有这个文件：
 *   配置器的交互界面由 assets/designer-app.js 驱动，那是 514 KB 的压缩构建产物
 *   （源码在 a9-deploy），改不了也不该改。所以这里在运行时把它写进 DOM 的英文
 *   界面文案按字典替换成当前语言。
 *   字典由 assets/tg-dsg-i18n.<locale>.js 提供（window.TG_DSG_DICT），
 *   两个文件都由 templates/page.designer.liquid 用 defer 按顺序加载，仅非英文时加载。
 *
 * 设计约束（改动前请先读）：
 *   1. 只做**整段精确匹配**（trim 后完全相等才替换），绝不做子串替换 —— 
 *      子串替换会毁掉颜色名、设计名、SKU 和用户自己输入的设计名。
 *   2. 字典里已剔除「译文等于原文」的条目，且构建时校验过「译文不会again命中另一个 key」，
 *      所以替换不会自我循环。
 *   3. 跳过 script/style/textarea/input/canvas/svg/iframe 与 [data-no-i18n] 子树。
 *   4. 属性只碰 placeholder / aria-label / title。
 *   5. 一旦这批文案搬回 a9-deploy 源码做正规 i18n，请删掉本文件与字典文件。
 */
(function () {
  var D = window.TG_DSG_DICT;
  if (!D) return;
  var SKIP = { SCRIPT:1, STYLE:1, NOSCRIPT:1, TEXTAREA:1, INPUT:1, CANVAS:1, IFRAME:1, SVG:1, 'MODEL-VIEWER':1 };
  var ATTRS = ['placeholder', 'aria-label', 'title'];

  function txText(node) {
    var t = node.nodeValue;
    if (!t) return;
    var k = t.trim();
    if (k.length < 2) return;
    var v = D[k];
    if (v === undefined) { txParts(node); return; }
    // 保留原有的前后空白，只换中间那段文字
    var i = t.indexOf(k);
    node.nodeValue = t.slice(0, i) + v + t.slice(i + k.length);
  }

  function txAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (!el.hasAttribute || !el.hasAttribute(a)) continue;
      var v0 = el.getAttribute(a);
      if (!v0) continue;
      var v = D[v0.trim()];
      if (v !== undefined && v !== v0) el.setAttribute(a, v);
    }
  }

  /* 目录卡片下的标签行：形如 "Bold · Abstract art · Blue · Orange"。
     这串由 designer-app.js 用目录数据拼出来，组合太多没法整句进字典，
     所以只对这一个 class 做「按 · 拆开、逐段查词表」的特例。
     词表 key 一律小写；查不到的段原样保留；译完之后段落已是目标语言，
     不会再命中英文词表，所以不会反复替换。 */
  var PARTS = window.TG_DSG_PARTS;
  var PARTS_SEL = '.match-catalog-reason-inner, .match-catalog-reason';
  function txParts(node) {
    if (!PARTS) return false;
    var el = node.parentElement;
    if (!el || !el.closest || !el.closest(PARTS_SEL)) return false;
    var t = node.nodeValue;
    if (!t || t.indexOf(' · ') === -1) return false;
    var segs = t.split(' · '), hit = false;
    for (var i = 0; i < segs.length; i++) {
      var v = PARTS[segs[i].trim().toLowerCase()];
      if (v !== undefined && v !== segs[i]) { segs[i] = v; hit = true; }
    }
    if (hit) node.nodeValue = segs.join(' · ');
    return hit;
  }

  function walk(n) {
    if (!n) return;
    if (n.nodeType === 3) { txText(n); return; }
    if (n.nodeType !== 1) return;
    var tag = n.tagName;
    if (SKIP[tag]) return;
    if (n.hasAttribute && n.hasAttribute('data-no-i18n')) return;
    txAttrs(n);
    for (var c = n.firstChild; c; c = c.nextSibling) walk(c);
  }

  var queued = false, pending = [];
  function flush() {
    queued = false;
    var list = pending; pending = [];
    for (var i = 0; i < list.length; i++) walk(list[i]);
  }
  function schedule(node) {
    pending.push(node);
    if (queued) return;
    queued = true;
    // 这里刻意用 setTimeout 而不是 requestAnimationFrame：
    //   1) rAF 在后台标签页不触发，页面在后台加载完再切回来就会是一片英文；
    //   2) 从 window 上摘下 rAF 再裸调用，Chrome 会抛 Illegal invocation。
    window.setTimeout(flush, 0);
  }

  function start() {
    walk(document.body);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) schedule(m.addedNodes[j]);
        } else if (m.type === 'characterData') {
          txText(m.target);
        } else if (m.type === 'attributes') {
          txAttrs(m.target);
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ATTRS
    });
    window.__tgDsgI18n = { dict: D, observer: mo, rescan: function () { walk(document.body); } };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
